import type { DialogProps } from '@bos/ui';
import { Dialog } from '@bos/ui';

import type { ReplaceTestIdWithAppOne } from '../const/testIds';

export type AppDialogProps = ReplaceTestIdWithAppOne<DialogProps>;

export const AppDialog = (props: AppDialogProps) => <Dialog {...props} />;
